/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2019-12-20 09:22:18
 */
export default [
  {
    path: '/liveManagement',
    name: '直播控制台',
    component: () => import('@/views/Application.vue'),
    hidden: false,
    meta: {
      title: '直播控制台',
      icon: 'fa fa-star iconTitle',
      role: ['live_worker'],
      level: 1
    },
    children: [
      {
        path: '/liveManagement',
        name: '直播控制台',
        hidden: false,
        component: () => import('@/views/live'),
        meta: {
          title: '直播控制台',
          icon: 'fa fa-star iconTitle',
          role: ['live_worker'],
          level: 1
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/live/index.js